export const TIPOSGARANTIAS = {
  IMOVEL: 1,
  AUTOMOVEL: 2,
  AVAL: 3,
  APLICACOES_FINANCEIRAS: 4,
  RECEBIVEIS: 5
};
